import axios from 'axios';

const API_BASE_URL = '/api/v1/admin';

export const bankAccountsApi = {
  getAll: () => {
    return axios.get(`${API_BASE_URL}/bank-accounts`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  getById: (id) => {
    return axios.get(`${API_BASE_URL}/bank-accounts/${id}`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  create: (data) => {
    return axios.post(`${API_BASE_URL}/bank-accounts`, data, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  update: (id, data) => {
    return axios.put(`${API_BASE_URL}/bank-accounts/${id}`, data, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  delete: (id) => {
    return axios.delete(`${API_BASE_URL}/bank-accounts/${id}`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  deactivate: (id) => {
    return axios.put(`${API_BASE_URL}/bank-accounts/${id}/deactivate`, {}, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  sync: (id) => {
    return axios.post(`${API_BASE_URL}/bank-accounts/${id}/sync`, {}, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  syncForPeriod: (id, fromDate, toDate) => {
    return axios.post(`${API_BASE_URL}/bank-accounts/${id}/sync/period`, null, {
      params: {
        from: fromDate,
        to: toDate
      },
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  }
};

export const paymentsApi = {
  getAll: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.paymentId) queryParams.append('paymentId', params.paymentId);
    if (params.bankAccountId) queryParams.append('bankAccountId', params.bankAccountId);
    if (params.bankType) queryParams.append('bankType', params.bankType);
    if (params.type) queryParams.append('type', params.type);
    if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
    if (params.dateTo) queryParams.append('dateTo', params.dateTo);
    if (params.amount) queryParams.append('amount', params.amount);
    if (params.searchQuery) queryParams.append('searchQuery', params.searchQuery);
    if (params.status !== undefined && params.status !== null && params.status !== '') queryParams.append('status', params.status);
    if (params.page) queryParams.append('page', params.page);
    if (params.numberPerPage) queryParams.append('numberPerPage', params.numberPerPage);

    return axios.get(`${API_BASE_URL}/payments?${queryParams.toString()}`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  getByBankAccountId: (bankAccountId) => {
    return axios.get(`${API_BASE_URL}/payments/bank-account/${bankAccountId}`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  getById: (id) => {
    return axios.get(`${API_BASE_URL}/payments/${id}`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  updateStatus: (id, status) => {
    return axios.put(`${API_BASE_URL}/payments/${id}/status`, null, {
      params: { status },
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  updateComment: (id, adminComment) => {
    return axios.put(`${API_BASE_URL}/payments/${id}/comment`, null, {
      params: { adminComment: adminComment || '' },
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  createManual: (data) => {
    return axios.post(`${API_BASE_URL}/payments/manual`, data, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  updateManual: (id, data) => {
    return axios.put(`${API_BASE_URL}/payments/${id}/manual`, data, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  }
};

export const paymentOrdersApi = {
  // Прикріпити оплату до замовлення
  attach: (paymentId, orderId, amount = null) => {
    const params = { paymentId, orderId };
    if (amount !== null) params.amount = amount;
    return axios.post(`${API_BASE_URL}/payment-orders/attach`, null, {
      params,
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  // Відкріпити оплату від замовлення
  detach: (paymentOrderId) => {
    return axios.delete(`${API_BASE_URL}/payment-orders/${paymentOrderId}`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  // Оновити суму прикріплення
  updateAmount: (paymentOrderId, amount) => {
    return axios.put(`${API_BASE_URL}/payment-orders/${paymentOrderId}/amount`, null, {
      params: { amount },
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  // Отримати прикріплення оплати
  getPaymentAttachments: (paymentId) => {
    return axios.get(`${API_BASE_URL}/payment-orders/payment/${paymentId}`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  },

  // Отримати прикріплення до замовлення
  getOrderAttachments: (orderId) => {
    return axios.get(`${API_BASE_URL}/payment-orders/order/${orderId}`, {
      headers: {
        Authorization: localStorage.getItem('token')
      }
    });
  }
};
